// Capa 2 de movimiento (§5.9.6): revelados sobrios en páginas editoriales.
// Si el navegador soporta animation-timeline: view(), lo hace el CSS. Si no, este observador (< 1 KB) añade
// una clase al entrar en pantalla. Sin JS, o con movimiento reducido, el contenido se ve siempre.
if (!CSS.supports('animation-timeline: view()') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const groups = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('reveal--visible');
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '0px 0px -10% 0px' });
  for (const group of groups) {
    if (group.getBoundingClientRect().top > innerHeight) {
      group.classList.add('reveal--pending');
      observer.observe(group);
    }
  }
}
